import React, { Component } from 'react';
import * as _ from 'lodash';
import Validator from 'validatorjs';
import { Row, Col, Form } from 'react-bootstrap';

import CfdisRelacionadosForm from './CfdisRelacionadosForm';
import CfdisRelacionadosList from './CfdisRelacionadosList';
import { TipoDeRelacion } from '../../../../support/catalogs/TipoDeRelacion';

// 'CfdiRelacionados' => [
//   'TipoRelacion' => '02',
//   'CfdiRelacionado' => [
//       [
//           'UUID' => '2ee6dc34-6d46-4a8c-a90f-b4d1e98f02c7'
//       ],
//       [
//           'UUID' => '8911861a-0302-4b99-af36-698c6f3f1462'
//       ],
//       [
//           'UUID' => '3b928673-5844-4e90-bc07-ba94b319fcea'
//       ]
//   ]
// ]

class CfdisRelacionadosManager extends Component {

  state = {}

  tipoDeRelacionCatalog = [];

  constructor(props) {
    super(props);

    const catalog = TipoDeRelacion.map(item => {
      return {
        label: `${item.descripcion} (${item.clave})`,
        value: item.clave
      }
    });

    this.tipoDeRelacionCatalog = _.sortBy(catalog, 'label');

    const data = props.data.CfdiRelacionados || {};

    this.state = {
      validator: new Validator({}, this.rules),
      data: data,
      isValid: false
    }
  }

  get rules() {
    return {
      'TipoRelacion': ['required'],
      'cfdis': ['required'],
    }
  }

  get catalog() {
    return [{
      label: 'Selecciona',
      value: ''
    }].concat(this.tipoDeRelacionCatalog);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!!prevProps.metadata && prevProps.metadata.cfdis_relacionados === false && this.props.metadata.cfdis_relacionados === true && !!this.props.data.CfdiRelacionados) {
      this.setState({
        data: {
          ...this.props.data.CfdiRelacionados
        }
      });
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
      isValid: validator.passes()
    });

    return validator;
  }

  handleOnChange = (event) => {
    const data = {
      ...this.state.data,
      ...event
    };

    this.validate(data);

    this.setState({
      data
    });
  }

  handleOnCfdisRelacionadosCheckboxChange = (event) => {
    const { name, checked} = event.target;
    const { data, data: { Metadata = {}, CfdiRelacionados = {} }} = this.props;

    this.props.onChange({
      ...data,
      Metadata: {
        ...Metadata,
        [name]: checked
      },
      CfdiRelacionados: checked === true ? CfdiRelacionados : undefined
    });

    this.validate(checked ? this.state.data : {});

    if (!checked) {
      this.setState({
        data: {}
      });
    }
  }

  handleOnCfdiSearchClick = (data) => {
    this.props.onChange(data);
  }

  render() {
    const { data } = this.state;
    const { comprobante, data: { Metadata = {}, CfdiRelacionados = {} } } = this.props;

    return (
      <>
        { !comprobante.isEgreso() && (
          <Row className="z-index-top">
            <Col>
              <Form.Group controlId="cfdis_relacionados">
                <Form.Check type="checkbox"
                  custom={ true }
                  name="cfdis_relacionados"
                  label="Agregar CFDIs relacionados"
                  checked={ Metadata.cfdis_relacionados || false }
                  onChange={ this.handleOnCfdisRelacionadosCheckboxChange }
                />
              </Form.Group>
            </Col>
          </Row>
        )}

        { Metadata.cfdis_relacionados && !CfdiRelacionados.CfdiRelacionado && (
          <CfdisRelacionadosForm
            data={ data }
            onChange={ this.handleOnCfdiSearchClick }
          />
        )}

        { !!CfdiRelacionados.CfdiRelacionado && (
          <>
            <CfdisRelacionadosList data = { CfdiRelacionados } />
          </>
        )}
      </>
    )
  }
}

export default CfdisRelacionadosManager;